import { Alert } from "@fluentui/react-northstar";
import React from "react";

export interface GenericErrorProps {
    message: string;
}

const GenericError: React.FC<GenericErrorProps> = ({ message }) => {
    return <Alert danger content={message} />;
};

export default GenericError;
